export class DeleteGodkendelseModel {
    constructor(forloebId: string, godkendelseId: string) {
        this.forloebId = forloebId;
        this.godkendelseId = godkendelseId;
    }

    public forloebId: string;
    public godkendelseId: string;
}
